import { render, staticRenderFns } from "./app-mian-head.vue?vue&type=template&id=59c2ddb8&scoped=true"
import script from "./app-mian-head.vue?vue&type=script&lang=js"
export * from "./app-mian-head.vue?vue&type=script&lang=js"
import style0 from "./app-mian-head.vue?vue&type=style&index=0&id=59c2ddb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2ddb8",
  null
  
)

export default component.exports